import React, { useEffect, createRef, useState } from 'react'

import TagsManagerUI from './TagsManagerUI'

const TagsManager = ({ tags, selectedTags, buttonToggleTitle, buttonEventTitle, handleSelectTag, handleAddTag, handleUpdateTag, handleDeleteTag }) => {
  const tagsRef = createRef()
  const [filteredTags, setFilteredTags] = useState([])
  const [isOpenManager, setIsOpenManager] = useState(false)
  const [searchValue, setSearchValue] = useState('')

  const toggleManager = () => setIsOpenManager(!isOpenManager)

  useEffect(() => {
    let filteredTags = []
    filteredTags = tags.filter(tag => tag.name.toLowerCase().includes(searchValue.toLowerCase()) && !selectedTags.some(selectedTagId => selectedTagId === tag._id))
    setFilteredTags(filteredTags.reverse())
    if (tagsRef.current) tagsRef.current.scrollTo(0, 0)
  }, [tags?.length, selectedTags?.length, searchValue])

  return (
    <TagsManagerUI
      isOpenManager={isOpenManager}
      setIsOpenManager={setIsOpenManager}
      toggleManager={toggleManager}
      searchValue={searchValue}
      setSearchValue={setSearchValue}
      tags={filteredTags}
      tagsRef={tagsRef}
      buttonToggleTitle={buttonToggleTitle}
      buttonEventTitle={buttonEventTitle}
      handleSelectTag={handleSelectTag}
      handleAddTag={handleAddTag}
      handleUpdateTag={handleUpdateTag}
      handleDeleteTag={handleDeleteTag}
    />
  )
}

export default TagsManager
